import React, { useContext, useState } from 'react';
import { Col, Container, Form, Image, Row } from 'react-bootstrap';
import ImgLogin from './../assets/img/login.png';
import Titulo from '../elements/Titulo';
import { Helmet } from 'react-helmet';
import Btn from '../elements/Btn';
import { auth } from '../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import Alert from './Alert';
import { ContextAlert } from '../context/ContextAlert';
import { dotoniwoofApi } from '../api/dotoniwooApi';

const SignUp = () => {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const { handleShow, alert, changeAlert } = useContext(ContextAlert);


    const handleChange = (e) => {
        switch (e.target.name) {
            case 'email':
                setEmail(e.target.value);
                break;
            case 'password':
                setPassword(e.target.value);
                break;
            case 'password2':
                setPassword2(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();


        const regularExpresion = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

        if (!regularExpresion.test(email)) {
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "El formato del correo es invalido",
                    header: "Error"
                }
            )
            return;
        }

        if (email === '' || password === '' || password2 === '') {
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "Todos los campos deben estar completos",
                    header: "Error"
                }
            )
            return;
        }

        if (password !== password2) {
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "Las contraseñas deben ser iguales",
                    header: "Error"
                }
            )
            return;
        }

        try {

            await createUserWithEmailAndPassword(auth, email, password);
            await onAuthStateChanged(auth, (user) => {
                 dotoniwoofApi.post("/user.php",
                    {
                        "firebase_UID":user.uid,
                        "name":"",
                        "email":email
                    }
                   );
                }
                
            );

        
    
            navigate('/inicio-sesion');
        } catch (error) {
            let message;
            switch (error.code) {
                case 'auth/email-already-in-use':
                    message = 'Ya existe una cuenta con el correo electronico proporcionado'
                    break;
                case 'auth/invalid-password':
                    message = 'Contraseña invalida'
                    break;
                default:
                    message = "Ocurrio un error en la creacion del usuario"
                    break;
            }


            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: message,
                    header: "Error"
                }
            )
        }




    }
    return (
        <>
            <Helmet>
                <title>Crear cuenta</title>
            </Helmet>
            <Container fluid className="d-flex vh-100">
                <Row className="justify-content-center align-self-center w-100 gx-0">
                    <Col sm >
                        <Image src={ImgLogin} style={{ width: '100%', height: 'auto' }} />
                    </Col >
                    <Col sm className=" align-self-center p-4">
                        <Form onSubmit={handleSubmit}>
                            <Titulo>¡Crea tu cuenta ahora mismo!</Titulo>
                            <p>
                                <span>
                                    ¿ya tienes una cuenta creada?
                                </span>
                            </p>
                            <p>
                                <a href='/inicio-sesion'>
                                    <b>Inicia sesión aquí</b>
                                </a>
                            </p>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label><strong>Correo electrónico</strong></Form.Label>
                                <Form.Control
                                    name='email'
                                    type="email"
                                    placeholder="Correo Electrónico"
                                    value={email}
                                    onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label><strong>Contraseña</strong></Form.Label>
                                <Form.Control
                                    name='password'
                                    type="password" placeholder="Contraseña"
                                    value={password}
                                    onChange={handleChange} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPassword2">
                                <Form.Control
                                    name='password2'
                                    type="password" placeholder="Repetir la contraseña"
                                    value={password2}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Btn as="button" type="submit">Crear cuenta</Btn>
                        </Form></Col>
                    <Alert message={alert.message} type={alert.type} header={alert.header}></Alert>
                </Row>
            </Container>
        </>
    );
}

export default SignUp;
